function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'atlantic-navy': 'rgb(46, 68, 139)','natural-beige': 'rgb(204, 184, 160)','lunar-grey': 'rgb(175, 178, 185)','stroller-lunar-grey': 'rgb(175, 178, 185)','midnight-black': 'rgb(0, 0, 0)','stroller-midnight-black': 'rgb(0, 0, 0)','one360-lunar-grey': 'rgb(175, 178, 185)','one360-midnight-black': 'rgb(0, 0, 0)','french-olive': 'rgb(86, 91, 77)','earth-nude': 'rgb(199, 168, 147)','earth-green': 'rgb(98, 112, 101)','stroller-french-olive': 'rgb(86, 91, 77)','tan': 'rgb(107, 68, 52)','grey': 'rgb(95, 90, 89)','nude': 'rgb(253, 222, 197)','pure-white': 'rgb(241, 240, 245)','pearl-grey': 'rgb(143, 130, 133)','white': 'rgb(241, 240, 245)','gold': 'rgb(207, 167, 115)','silver': 'rgb(207, 201, 212)','grey': 'rgb(145, 143, 165)','green': 'rgb(187, 214, 202)','pink': 'rgb(243, 152, 151)','beach-cottage': 'rgb(3, 145, 189)','lavender-vanilla': 'rgb(189, 154, 194)','clean-cotton': 'rgb(235, 214, 138)','natural-biscuit': 'rgb(189, 177, 161)','midnight-koala': 'rgb(97, 97, 95)',};

    this.images = {};

    this.triggers = ['colour','stroller colour','colour of one360','colour of cruiser trike','colour of explore stroller','colour of 2x one360','couleur','farbe','cor','fragrance',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
